<template>
  <div id="app">
    <layout/>
  </div>
</template>

<script>
import layout from '@/components/layout.vue'

export default {
  name: 'App',
  components: {layout}
}
</script>

<style>
/* 清除默认样式 */
body,div,ul,ol,li,dl,dt,dd,h1,h2,h3,h4,h5,h6,form,input,textarea,p {margin:0;padding:0;}
body{font-size:14px;color:#333;}
ul li{list-style:none;}
img,a img {border:none;}
a{text-decoration:none;}
a:hover {text-decoration:none;}
i {font-style: normal;}
/* 清除默认样式 */

#app{
  width: 100%;
  height: 100%;
}
</style>
